import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['submitButton']

  connect() {
    this.submitButtonTarget.addEventListener('click', this.handleSubmit)
  }

  disconnect() {
    this.submitButtonTarget.removeEventListener('click', this.handleSubmit)
  }

  handleSubmit = (event) => {
    const confirmMessage = this.submitButtonTarget.dataset.confirmMessage
    
    if (confirmMessage && !confirm(confirmMessage)) {
      event.preventDefault()
      return false
    }
  }
}